import { pumaAPI } from "../api"
import { IActionButton } from "../../components/resources"
import { ShortcutDataDTO } from "../models/dto/shortcut"

// we can use this shortcut implementation to validate an internal link
// and return the needed parameters for the action buttons
export const getActionButtonData = (
    internalLink: string,
): Promise<IActionButton> =>
    pumaAPI
        .postJSON("shortcuts/validate", internalLink)
        .then((linkData: ShortcutDataDTO) => {
            const actionButton: IActionButton = {
                id: internalLink,
                doesExist: true,
                linkData: {
                    itemId: linkData.ItemId,
                    parentId: linkData.ParentId,
                    conceptId: linkData.ListId,
                    collectionId: linkData.SelectionId,
                    workspaceId: linkData.WorkspaceId,
                    attachmentId: linkData.AttachmentId,
                    scriptId: linkData.ScriptId,
                    listScriptId: linkData.ListScriptId,
                    hasParameters: linkData.HasParameters,
                },
            }

            return actionButton
        })
